import { render, staticRenderFns } from "./RedditiPatrimonioForm.vue?vue&type=template&id=00868512&"
import script from "./RedditiPatrimonioForm.vue?vue&type=script&lang=js&"
export * from "./RedditiPatrimonioForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RedditiPatrimonioForm.vue"
export default component.exports